import {Outlet, useLocation} from 'react-router-dom';
import {RequireAuth} from '../../../services';
import Navbar from '../Navbar';
import HamburgerMenu from '../HamburgerMenu';
import {Sync} from '../../../api';
import {useEffect} from 'react';
import {useAuthContext} from '../../../context';
import {hasUnsyncedChanges} from '@nozbe/watermelondb/sync';
import {database} from '../../../pos-core/database';

const Menu = () => {
    const {pathname} = useLocation();
    const {user} = useAuthContext();

    const isMenuHidden = pathname == '/business-details' ? true : false;

    const checkUnsyncedChanges = async () => {
        if (user?.username) {
            let timer = setTimeout(async () => {
                // let syncStatus = await hasUnsyncedChanges({database});
                // console.log('syncStatus--', syncStatus);
                console.log('IN Sync');
                // if (syncStatus) {
                await Sync(user.username);
                // }
            }, 500);
            return () => clearTimeout(timer);
        }
    };

    useEffect(() => {
        checkUnsyncedChanges();
    }, [pathname]);

    return (
        <RequireAuth>
            {isMenuHidden ? null : (
                <>
                    <Navbar />
                    <HamburgerMenu />
                </>
            )}

            <Outlet />
        </RequireAuth>
    );
};

export default Menu;
